import { createContext, useContext } from 'react'
import { CategoryProduct, SelectedFilter } from '../models'
import { AvailableSorting, Filter } from '../models/shop-product-category.model'

interface ShopProductCategoryContextProps {
  categoryId: string
  loadMoreButtonLoading: boolean
  products: CategoryProduct[] | null
  isLoading: boolean
  activePage: number
  totalPages: number
  totalProducts: number
  filters: Filter[]
  selectedFilters: SelectedFilter[]
  currentSorting: string
  availableSortings: AvailableSorting[]
  setCategoryId: React.Dispatch<React.SetStateAction<string>>
  setSelectedFilters: React.Dispatch<React.SetStateAction<SelectedFilter[]>>
  setActivePage: React.Dispatch<React.SetStateAction<number>>
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  setProducts: React.Dispatch<React.SetStateAction<CategoryProduct[] | null>>
  setCurrentSorting: React.Dispatch<React.SetStateAction<string>>
  setAvailableSortings: React.Dispatch<React.SetStateAction<AvailableSorting[]>>
  fetchProducts: (id: string, page: number, sorting: string, filters?: SelectedFilter[], isSearch?: boolean) => Promise<void>
}

export const ShopProductCategoryContext = createContext<ShopProductCategoryContextProps | undefined>(undefined)

export const useShopProductCategoryContext = (): ShopProductCategoryContextProps => {
  const context = useContext(ShopProductCategoryContext)
  if (!context) {
    throw new Error('useShopProductCategoryContext must be used within a ShopProvider')
  }
  return context
}
